import { useEffect, useState } from "react";
import { getAboutUs, getStatistics } from "../../../api/apiServices";

export default function AboutSection() {
const [stats, setStats] = useState([]);
  const [about, setAbout] = useState(null);

  useEffect(() => {
      fetchAbout();
      fetchStats();
    }, []);
  
    const fetchAbout = async () => {
      try {
        const res = await getAboutUs();
        if (res?.data) {
          setAbout(res.data);
        }
      } catch (err) {
        console.error("Failed to fetch about info", err);
      }
    };

      const fetchStats = async () => {
        try {
          const res = await getStatistics();
          setStats(res.data || []);
        } catch (err) {
          console.error("Failed to fetch statistics", err);
        }
      };

  return (
    <section id="about" className="bg-[#6a4bc3] py-16 sm:py-24 lg:py-32 px-4 sm:px-6 lg:px-20">
      <div className="max-w-7xl mx-auto text-center">
        {/* Header */}
        <p className="text-white/70 text-xs uppercase tracking-wider mb-6 sm:mb-8">
          OUR FOUNDATION
        </p>
        
        <h2 className="font-bold text-white mb-12 sm:mb-16 lg:mb-20">
          <div className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl mb-2">{about?.title}</div>
        </h2>

        {/* Stats */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 lg:gap-12">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="bg-white/15 backdrop-blur-sm rounded-xl sm:rounded-2xl p-6 sm:p-8 lg:p-12 hover:bg-white/20 transition-all duration-300 hover:-translate-y-2"
            >
              <div className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-[#c9a24d] mb-2 sm:mb-4">
                {stat.number}
              </div>
              <div className="text-white text-sm sm:text-base lg:text-lg font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        {/* Mission Statement */}
        {/* <div className="mt-12 sm:mt-16 lg:mt-20 max-w-4xl mx-auto">
          <p className="text-white/90 text-sm sm:text-base lg:text-lg leading-relaxed">
            {about?.mission}
          </p>
        </div> */}
      </div>
    </section>
  );
}
